import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedPipeModule } from '@app/shared/pipes/shared.pipe.module';

@Component({
  selector: 'app-more-information-dialog',
  templateUrl: 'moreInformation.html',
  styleUrls: ['../../dialogs.scss'],
  standalone: true,
  imports: [SharedPipeModule],
})
export class MoreInformationDialogComponent {
  title: string;
  description: string;
  subLine: string;
  completionRate: number;

  constructor(
    public dialogRef: MatDialogRef<MoreInformationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.title = data.title;
    this.subLine = data.subLine;
    this.description = data.description;
    this.completionRate = data.completionRate;
  }

  close(res: any = null): void {
    this.dialogRef.close(res);
  }
}
